import apiClient from "./client";
import mockClient from "./mockClient";

const client = window.location.href.includes("localhost:3000") ? mockClient : apiClient;

export default client;